import EmailPage from "./EmailPage";
export default EmailPage;
